var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrinning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 28.38C22.9224 28.38 28.38 22.9224 28.38 16.19C28.38 9.45764 22.9224 4 16.19 4C9.45764 4 4 9.45764 4 16.19C4 22.9224 9.45764 28.38 16.19 28.38Z",
    fill: "url(#paint0_radial_179_8981)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.19 28.38C22.9224 28.38 28.38 22.9224 28.38 16.19C28.38 9.45764 22.9224 4 16.19 4C9.45764 4 4 9.45764 4 16.19C4 22.9224 9.45764 28.38 16.19 28.38Z",
    fill: "url(#paint1_radial_179_8981)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3606 8.22397C13.2472 7.74773 12.6632 7.57197 11.7787 7.78173C11.0247 7.96317 9.47681 8.76829 8.68869 10.4976C8.54129 10.815 8.89849 10.8888 9.06289 10.662C9.61853 9.90225 11.3081 8.69457 12.8106 8.50749C13.4173 8.43377 13.3606 8.22397 13.3606 8.22397Z",
    fill: "url(#paint2_linear_179_8981)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2102 16.1447C12.9398 16.1447 13.5313 14.9592 13.5313 13.4969C13.5313 12.0346 12.9398 10.8491 12.2102 10.8491C11.4806 10.8491 10.8892 12.0346 10.8892 13.4969C10.8892 14.9592 11.4806 16.1447 12.2102 16.1447Z",
    fill: "url(#paint3_radial_179_8981)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2099 11.7451C12.7769 11.7451 13.2702 12.4028 13.5253 13.3666C13.5083 11.9322 12.9243 10.7812 12.2099 10.7812C11.4899 10.7812 10.9115 11.9322 10.8945 13.3666C11.1497 12.4028 11.6429 11.7451 12.2099 11.7451Z",
    fill: "url(#paint4_linear_179_8981)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4224 18.2541C24.3317 18.2201 24.2296 18.2144 24.1389 18.2428C21.5649 18.9798 18.8944 19.3484 16.1956 19.3484C13.4968 19.3484 10.8206 18.9742 8.25221 18.2428C8.15585 18.2144 8.05945 18.2201 7.96873 18.2541C7.69093 18.3675 7.24869 18.787 7.83265 20.3916V20.3972C8.69445 22.4497 10.9794 26.0557 16.1899 26.0557C21.3891 26.0557 23.674 22.444 24.5585 20.3972C25.1368 18.787 24.7002 18.3675 24.4224 18.2541Z",
    fill: "url(#paint5_radial_179_8981)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1904 25.4827C18.3506 25.4827 19.9721 24.8193 21.1855 23.9122C19.8531 23.3112 18.2088 22.9199 16.1904 22.9199C14.172 22.9199 12.5277 23.3168 11.1953 23.9235C12.4087 24.8193 14.0302 25.4827 16.1904 25.4827Z",
    fill: "url(#paint6_radial_179_8981)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2577 18.2197C24.2407 18.2197 24.2237 18.2197 24.201 18.2254C21.6042 18.9738 18.9111 19.3537 16.1839 19.3537C13.4568 19.3537 10.7636 18.9738 8.16691 18.2254C8.14987 18.2197 8.13287 18.2197 8.11019 18.2197C7.93443 18.2368 7.09531 18.4125 7.81535 20.3969V20.4026C8.16691 21.2304 8.75087 22.3133 9.66371 23.3055C8.80759 22.2906 9.86215 21.7293 11.7388 21.9561C13.6155 22.1829 16.1839 22.1886 16.1839 22.1886C16.1839 22.1886 18.7467 22.1829 20.629 21.9561C22.5057 21.7293 23.5603 22.2906 22.7042 23.3055C23.617 22.3133 24.201 21.2304 24.5525 20.4026V20.3969C25.2726 18.4068 24.4335 18.2311 24.2577 18.2197Z",
    fill: "url(#paint7_linear_179_8981)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8126 21.0091C23.527 20.856 24.0657 20.2607 24.1337 19.5293L24.2017 18.8149C21.605 19.5463 18.9118 19.9205 16.1904 19.9205C13.4689 19.9205 10.7757 19.5463 8.17896 18.8149L8.24699 19.5293C8.31503 20.2551 8.85367 20.8504 9.56807 21.0091C11.7339 21.4797 13.9565 21.7122 16.1904 21.7122C18.4242 21.7122 20.6468 21.4741 22.8126 21.0091Z",
    fill: "url(#paint8_radial_179_8981)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0195 8.22397C19.1329 7.74773 19.7169 7.57197 20.6014 7.78173C21.3554 7.96317 22.9033 8.76829 23.6914 10.4976C23.8388 10.815 23.4816 10.8888 23.3172 10.662C22.7615 9.90225 21.072 8.69457 19.5695 8.50749C18.9628 8.43377 19.0195 8.22397 19.0195 8.22397Z",
    fill: "url(#paint9_linear_179_8981)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1702 16.1447C20.8998 16.1447 21.4912 14.9592 21.4912 13.4969C21.4912 12.0346 20.8998 10.8491 20.1702 10.8491C19.4406 10.8491 18.8491 12.0346 18.8491 13.4969C18.8491 14.9592 19.4406 16.1447 20.1702 16.1447Z",
    fill: "url(#paint10_radial_179_8981)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1701 11.7451C19.6031 11.7451 19.1099 12.4028 18.8547 13.3666C18.8717 11.9322 19.4557 10.7812 20.1701 10.7812C20.8902 10.7812 21.4685 11.9322 21.4855 13.3666C21.2303 12.4028 20.7371 11.7451 20.1701 11.7451Z",
    fill: "url(#paint11_linear_179_8981)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_179_8981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7916 11.2498) scale(14.7056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB82E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_179_8981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7916 11.2498) scale(11.5696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_8981",
    x1: 11.0499,
    y1: 9.61177,
    x2: 10.7526,
    y2: 8.36217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_179_8981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8112 13.564) rotate(77.7198) scale(2.52723 1.27216)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_8981",
    x1: 12.2102,
    y1: 10.8348,
    x2: 12.2102,
    y2: 13.3042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_179_8981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1899 22.14) scale(6.71524)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_179_8981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2909 24.5019) scale(5.56548 1.68244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_179_8981",
    x1: 24.7459,
    y1: 20.7592,
    x2: 7.7373,
    y2: 20.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_179_8981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1904 20.2662) scale(14.7267 14.7267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8BBBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_179_8981",
    x1: 21.328,
    y1: 9.60793,
    x2: 21.6253,
    y2: 8.35833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_179_8981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5702 13.5632) rotate(102.28) scale(2.52723 1.27216)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_179_8981",
    x1: 20.1698,
    y1: 10.8349,
    x2: 20.1698,
    y2: 13.3042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinning);
export default __webpack_public_path__ + "static/media/Grinning.7753b3e5e4caf53991ba94eba4bce7b8.svg";
export { ForwardRef as ReactComponent };